import React, { useRef, useEffect } from 'react';
import { useState } from 'react';
// import axios from "axios"
import { useLocation, Link } from 'react-router-dom';
import classNames from 'classnames';

// PrimeReact Components
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { useNavigate } from "react-router-dom";
import { Ripple } from 'primereact/ripple';
import { FilterMatchMode } from 'primereact/api';
import { Dialog } from 'primereact/dialog';


import { Checkbox } from 'primereact/checkbox';
import { InputSwitch } from "primereact/inputswitch";

// import { RadioButton } from "primereact/radiobutton";

// import { InputMask } from 'primereact/inputmask';


// import { Steps } from 'primereact/steps';
// import { read, utils } from "xlsx";
// import { Button } from 'primereact/button';
// import UploadComponent from './UploadComponent';
// import DataTableComponent from '../../components/DataTable';
// import StepsNavigation from '../../components/StepsNavigation';
// import { InputText } from 'primereact/inputtext';
// import AlertComponent from '../../components/Alert';
// import Reviewsubmit from './Reviewsubmit';


// Import Styles
import '../../styles/pages/addcsv.scss';

//  Import the Sample Table component
// import SamplesTable from '../../components/DataSamplesTable';

// Import the Data Search component
// import DataSearch from '../../components/DataSearch';

const groupIds = JSON.parse(sessionStorage.getItem('usergroups'));
const userId = JSON.parse(sessionStorage.getItem('userid'));
const userToken = JSON.parse(sessionStorage.getItem('apitoken'));


function ExistingSampleManagement() {
    // const [samples, setSamples] = useState([]);
    // const [columns, setColumn] = useState([]);
    const navigate = useNavigate(); 
    const [loading, setLoading] = useState(false)
    // const [error, setError] = useState("")
    // const [keys, setKeys] = useState([]);
    // const dataTableLoaded = useRef(false);
    // const [bulkJson, setBulkJson] = useState([]);
    // const [csvErrors, setCSVErrors] = useState([]);
    // const [activeIndex, setActiveIndex] = useState(0);

    // const [products, setProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState(null);
    const [rowClick, setRowClick] = useState(true);     // eslint-disable-line no-unused-vars

    const [data, setData] = useState(null);


    useEffect(() => {
        document.title = `Data -> Existing Samples | Palmona Pathogenomics`
    }, []);

    const location = useLocation();
    const [name, setName] = useState(null);
    const [datasetId, setDatasetId] = useState(null);

    const [showAllSamplesChecked, setShowAllSamplesChecked] = useState(false);



    const [globalFilterValue, setGlobalFilterValue] = useState('');

    const [visible4, setVisible4] = useState(false);
    const [checked, setChecked] = useState(false);
    const [datasetNameValue, setDatasetNameValue] = useState('');


    const [visible5, setVisible5] = useState(false);
    const [selectedColumns, setSelectedColumns] = useState([]);
    const [columnsRowClick, setColumnsRowClick] = useState(true);   // eslint-disable-line no-unused-vars

    const [activeTab, setActiveTab] = useState(0);      // eslint-disable-line no-unused-vars



    const filter_columns = () => {
        // const mySet = new Set();

        const returnList = [];

        returnList.push('name');
        returnList.push('date');
        returnList.push('file1');
        returnList.push('file2');
        returnList.push('longitude');
        returnList.push('latitude');

        selectedColumns.forEach((item) => {
            returnList.push(item.field.toLowerCase());
        });

        return returnList;
    };


    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        sample: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        file1: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        file2: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        longitude: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        latitude: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        // 'country.name': { value: null, matchMode: FilterMatchMode.STARTS_WITH },
        // representative: { value: null, matchMode: FilterMatchMode.IN },
        // status: { value: null, matchMode: FilterMatchMode.EQUALS },
        // verified: { value: null, matchMode: FilterMatchMode.EQUALS }
    });

    // Set the dataset name
    useEffect(() => {
        if (location.state){
            setName(location.state.name);
        }

        // set the dataset ID
        if (location.state){
            setDatasetId(location.state.id);
        }
    }, [location.state]);

    useEffect(() => {
        // get the Samples data from the API
        const getDataUserId    = JSON.parse(sessionStorage.getItem('userid'));
        const getDataUserToken = JSON.parse(sessionStorage.getItem('apitoken'));

        const getData = async () => {
            setLoading(true);
            
            if (!showAllSamplesChecked) {
                try {
                    const response = await fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample_nodataset?userId=${getDataUserId}`,
                    {
                        method: "GET",
                        headers: {
                            // "Content-Type": "application/json",
                            Authorization: `Bearer ${getDataUserToken}`,
                        }
                    }
                    );
                    setData(response.ok ? await response.json() : null);
                    // setError(null);
                } catch (err) {
                    // setError(err.message);
                    setData(null);
                } finally {
                    setLoading(false);
                }
            } else {
                try {
                    const response = await fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/sample?userId=${getDataUserId}`,
                    {
                        method: "GET",
                        headers: {
                            // "Content-Type": "application/json",
                            Authorization: `Bearer ${getDataUserToken}`,
                        }
                    }
                    );
                    setData(response.ok ? await response.json() : null);
                    // setError(null);
                } catch (err) {
                    // setError(err.message);
                    setData(null);
                } finally {
                    setLoading(false);
                }
            }
        };

        getData();
    }, [showAllSamplesChecked]);

    const [columns, setColumns] = useState([]);

    useEffect(() => {
        if ( data ) {
            const mySet = new Set();

            data.forEach((item) => {
                item.sampleattributes.forEach((attr) => {
                    mySet.add(attr.name.toLowerCase());
                });
            });

            setColumns([]);
            mySet.forEach((item) => {
                // If the column is on of id, sample, date, file1, file2, longitude, latitude, origin, transmissionRate, skip it
                if ( item.toLowerCase() === 'id' || 
                     item.toLowerCase() === 'sample' || 
                     item.toLowerCase() === 'date' || 
                     item.toLowerCase() === 'file1' || 
                     item.toLowerCase() === 'file2' || 
                     item.toLowerCase() === 'longitude' || 
                     item.toLowerCase() === 'latitude') {
                    return;
                }
                // Add the remaining columns to the columns array
                setColumns(columns => [...columns, {field: item.trim().toLowerCase(), header: item.trim().toUpperCase()}]);
            });
        }
    }, [ data ]);

    async function patchDataset(sample) {
        // Patch the sampleId to the dataset
        const formData = new FormData();
        formData.append('userId' , userId);
        formData.append('sampleId', sample.id);

        const headers = {
            Authorization: `Bearer ${userToken}`,
        };

        try {
            const response = await fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset/${datasetId}`, {
                method: 'PATCH',
                headers: headers,
                body: formData
            });

            await response.json();
            // const dataset = await response.json();
            // console.log('patchDataset', dataset);

        } catch (error) {
            console.log(error);
        }
    };



    const postDataset = () => {
        // Create a new dataset 
        const formData = new FormData();
        formData.append('ownerId' , userId);
        formData.append('groupId', groupIds);
        formData.append('name', datasetNameValue);    
        formData.append('public', checked);

        const headers = {
            Authorization: `Bearer ${userToken}`,
        };

        try {
            fetch(`${process.env.REACT_APP_WORKFLOW_API_PATH}wfapi/dataset`, {
                method: 'POST',
                headers: headers,
                body: formData
            })
                .then(res => res.json())
                .then(dataset => {
                    setDatasetId(dataset.id);
                    setVisible4(false);
                    toast.current.show({severity:'success', summary: 'Success', detail:'New dataset created', life: 3000});
                })
        } catch (error) {
            console.log(error);
            setDatasetId(null);
        }
    };


    useEffect(() => {
        if (datasetId && selectedProducts) {
            const promises = [];
            // Patch the selected samples (selectedProducts) to the dataset
            selectedProducts.forEach((item) => {
                promises.push(patchDataset(item));
            });

            // Wait for all the promises to resolve
            Promise.all(promises)
            .then(() => {
                // Reset the state
                setVisible4(false);
                setDatasetNameValue('');
                setChecked(false);
                setSelectedProducts(null);

                // Navigate to the dataset details page
                nav_to_dataset(datasetId);
            });
        }
    }, [datasetId, selectedProducts]);          // eslint-disable-line react-hooks/exhaustive-deps

    function samples(props) {
        
        if (!data) {
            // return ( static_samples );
            return ( [] );
        } else {


            const returnItem = [];
            data.map((item, index) => {

                if (item.files.length > 0 && item.files[0]) {
                    item.file1 = item.files[0].name
                }

                if (item.files.length > 1 && item.files[1]) {
                    item.file2 = item.files[1].name
                }

                if (item.createdAt) {
                    item.date = item.createdAt.split('T')[0];
                }

                if (item.sampleattributes.length > 0 ) {
                    
                    // console.log('item.sampleattributes', item.sampleattributes);


                    // This needs to add all of the the attributes to the item
                    item.sampleattributes.map((attr, index) => {
                        if (attr.name.toLowerCase() === 'longitude') {
                            item.longitude = attr.value;
                        }
                        if (attr.name.toLowerCase() === 'latitude') {
                            item.latitude = attr.value;
                        }
                        if (attr.name.toLowerCase() === 'origin') {
                            item.origin = attr.value;
                        }
                        if (attr.name.trim().replace(/\s/g, '').toLowerCase() === 'transmissionrate') {
                            item.transmissionRate = attr.value;
                        }

                        item[(attr.name.trim().toLowerCase())] = attr.value;

                    });
                }
                returnItem.push(
                    item
                )
            });
            return (returnItem);
        }
    };



    const sampleBodyTemplate = (sample) => {
        // return <Button icon="pi pi-info-circle" label={sample.sample} link size='small' onClick={nav_to_sample(sample.id)}/>;
        // return (
        //     <a onClick={() => nav_to_sample(sample.id)}
        //                         className={classNames('p-ripple flex align-items-center cursor-pointer p-3 lg:justify-content-center hover:bg-indigo-400 border-round text-indigo-100 hover:text-indigo-50 transition-duration-150 transition-colors', { 'bg-indigo-700': activeTab === 0 })}>
        //                         <i className="pi pi-search text-sm pr-2"></i>{sample.name}
        //                         <Ripple />
        //                     </a>
        // // <img src={`https://primefaces.org/cdn/primereact/images/product/${sample.id}`} alt={sample.id} className="w-6rem shadow-2 border-round" />
        // );

        return (
            <div>
                {/* <i className={ !fileIsDeleted ? deletedClass : notDeletedClass} /> */}
                <Link to={`/datasets/sample_details?sampleid=${sample.id}`} className="ml-2">{sample.name}</Link>
            </div>
        );
    };


    // Select Sample button to go to the sample details page
    const nav_to_sample = (sampleId) => {
        const path = `/datasets/sample_details?sampleid=${sampleId}` ; 
        navigate(path);
    }

    const nav_to_dataset = (datasetId) => {
        const path = `/datasets/dataset_details?datasetid=${datasetId}` ; 
        navigate(path);
    }

    const toast = useRef(null);


    // Filters


    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const renderHeader = () => {
        return (
            <div className="flex justify-content-end">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                </span>
            </div>
        );
    };

    const header = renderHeader();

    // end of Filters


    useEffect(() => {
        if (selectedColumns.length > 0) {

            selectedColumns.forEach((item) => {

                // Add the remaining columns to the filters array
                const newFilter = { ...filters };

                // Add the new property to newFilter
                newFilter[item.field.trim().toLowerCase()] = { value: null, matchMode: FilterMatchMode.STARTS_WITH };

                // Set the new filter
                setFilters(newFilter);
            });
        } else {
            // Reset the filters
            setFilters({
                global: { value: null, matchMode: FilterMatchMode.CONTAINS },
                sample: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
                name: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
                date: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
                file1: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
                file2: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
                longitude: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
                latitude: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
            });
        }

    }, [selectedColumns]);

    return (
        <main className='mt-2'>

            <Dialog
                visible={visible4}
                onHide={() => setVisible4(false)}
                modal
                breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                header={
                    <div className="flex flex-column gap-2">
                        <h1 className="m-0 text-900 font-semibold text-xl line-height-3">Create New Dataset</h1>
                        <span className="text-600 text-base font-normal">The following information is required to create a new Dataset.</span>
                    </div>
                }
                footer={
                    <div className="flex gap-3 justify-content-end border-top-1 surface-border pt-5">
                        <Button label="Cancel" onClick={() => setVisible4(false)} className="p-button-text"></Button>
                        <Button label="Create" onClick={() => postDataset(true)} className="p-button-rounded"></Button>
                    </div>
                }
                style={{ width: '52vw' }}
                draggable={false}
                resizable={false}>
                <form className="flex flex-column gap-3 mt-3">
                    <div>
                        <label htmlFor="datasetname" className="block mb-1 text-color text-base">
                            Dataset Name
                        </label>
                        <span className="p-input-icon-left w-full">
                            <i className="pi pi-chart-bar"></i>
                            <InputText id="datasetname" value={datasetNameValue} onChange={(e) => setDatasetNameValue(e.target.value)}name="datasetname" type="text" className="w-full" tooltip="Enter a name for the new Dataset." tooltipOptions={{ position: 'top' }}/>
                        </span>
                    </div>

                    <div className="flex gap-3">
                        <div className="w-full">
                            <label htmlFor="cvc" className="block mb-1 text-color text-base">
                                Is this a Public Dataset?
                            </label>
                            <span className="p-input-icon-left w-full">
                                {/* <i className="pi pi-lock"></i> */}
                                {/* <InputText id="cvc" name="cvc" type="text" className="w-full" keyfilter="int" maxLength={3} value={cvc} onChange={(e) => setCvc(e.target.value)} placeholder="123" /> */}
                                {/* <div className="card flex justify-content-center"> */}
                                <Checkbox onChange={e => setChecked(e.checked)} checked={checked} tooltip="A Public Dataset is avaliable to ALL USERS! Select with caution."></Checkbox>
                                {/* </div> */}
                            </span>
                        </div>
                        {/* <div className="w-full">
                            <label htmlFor="expiration" className="block mb-1 text-color text-base">
                                Expiration
                            </label>
                            <span className="p-input-icon-left w-full">
                                <i className="pi pi-clock"></i>
                                <InputMask id="expiration" type="text" name="exp" mask="99/99" value={expiration} onChange={(e) => setExpiration(e.target.value)} className="w-full" placeholder="12/22" />
                            </span>
                        </div> */}
                    </div>
                </form>
            </Dialog>


            {/* Column Selection Dialog */}
            <Dialog
                visible={visible5}
                onHide={() => setVisible5(false)}
                modal
                breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                header={
                    <div className="flex flex-column gap-2">
                        <h1 className="m-0 text-900 font-semibold text-xl line-height-3">Show Attitional Attribute Columns</h1>
                        <span className="text-600 text-base font-normal">Select Attribute Fields below for display.</span>
                    </div>
                }
                footer={
                    <div className="flex gap-3 justify-content-end border-top-1 surface-border pt-5">
                        <Button label="Cancel" onClick={() => setVisible5(false)} className="p-button-text"></Button>
                        <Button label="Show Attributes" onClick={() => setVisible5(false)} className="p-button-rounded"></Button>
                    </div>
                }
                style={{ width: '52vw' }}
                draggable={false}
                resizable={false}>
                <form className="flex flex-column gap-3 mt-3">
                    <div>
                        <label htmlFor="attributename" className="block mb-1 text-color text-base">
                            Attribute Name
                        </label>
                        <span className="p-input-icon-left w-full">
                            <DataTable 
                                value={columns} 
                                selectionMode={columnsRowClick ? null : 'checkbox'} 
                                selection={selectedColumns} 
                                onSelectionChange={(e) => setSelectedColumns(e.value)} 
                                dataKey="field" 
                                id="attributename"
                                tableStyle={{ minWidth: '40rem' }}>
                                    <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>
                                    <Column field="field" header="Field" headerStyle={{ width: '3rem' }}></Column>
                            </DataTable>
                        </span>
                    </div>
                </form>
            </Dialog>
            {/* End of Column Selection Dialog */}



            { name && <p>{name} : {datasetId}</p> }

            <div className="d-flex justify-content-between">
                <div className="h5">
                { !showAllSamplesChecked ? <span>Existing Samples</span> : <span>All Samples</span> }
                </div>


                {/* <div className="card flex justify-content-center"> */}
                <div className="card d-flex p-2">
                    <div className="flex flex-wrap gap-3 m-1">
                        Display All Samples
                    </div>
                    <div className="flex flex-wrap gap-3 m-1 justify-content-center">
                        <InputSwitch checked={showAllSamplesChecked} onChange={(e) => setShowAllSamplesChecked(e.value)} />
                    </div>
                </div>


                <div className='ml-3 mr-3'>
                    &nbsp;
                <div className='mb-2'>
                    <Button className="pi pi-eye mr-2" label="Select Columns" onClick={() => setVisible5(true)} ></Button>
                </div>
                </div>
            </div>

            <div className='mt-2 pt-2 mb-0 pb-0'>
                <span><p><strong>Total { samples().length } samples are available to configure the dataset.</strong></p></span>
                
                { !showAllSamplesChecked ? <p>These Samples currently are not attached to any Dataset.</p> : <p>Displaying <strong>All Samples</strong>.</p> }
            </div>

            <div>

                <div className=''>
                    <Toast ref={toast} />
                    <DataTable 
                        value={samples()} 
                        // selectionMode="single" 
                        selectionMode={rowClick ? null : 'checkbox'}
                        selection={ selectedProducts } 
                        onSelectionChange={(e) => setSelectedProducts(e.value)} 
                        dataKey="id"
                        // onRowSelect={onRowSelect} 
                        // onRowUnselect={onRowUnselect} 
                        // metaKeySelection={false} 
                        tableStyle={{ minWidth: '50rem' }}
                        filters={ filters } 
                        filterDisplay="row" 
                        loading={loading}
                        // globalFilterFields={['sample', 'date', 'file1', 'file2', 'longitude', 'latitude', 'origin', 'transmissionrate']} 
                        globalFilterFields={ filter_columns() }
                        header={ header } 
                        emptyMessage="No samples found."
                        paginator rows={10} rowsPerPageOptions={[10, 25, 50, 100]}
                    >

                        <Column selectionMode="multiple" headerStyle={{ width: '3rem' }}></Column>

                        <Column field="name" body={sampleBodyTemplate} header="Sample" sortable style={{ width: '10rem', minWidth: '10rem', maxWidth: '20rem'}} filter filterPlaceholder="Search by name" />

                        <Column field="date" body={samples().date} header="Date" sortable style={{ width: '10rem' }} filter filterPlaceholder="Search by Date" />
                        <Column field="file1" body={samples().file1} header="File1" sortable style={{ width: '10rem' }} filter filterPlaceholder="Search by File1" />
                        <Column field="file2" body={samples().file2} header="File2" sortable style={{ width: '10rem' }} filter filterPlaceholder="Search by File2"/>
                        <Column field="longitude" body={samples().longitude} header="Longitude" sortable style={{ width: '10rem' }} filter filterPlaceholder="Search by Longitude"/>
                        <Column field="latitude" body={samples().latitude} header="Latitude" sortable style={{ width: '10rem' }} filter filterPlaceholder="Search by Latitude"/>

                        { selectedColumns.map((col, i) => (
                                <Column key={col.field.toLowerCase()} field={col.field.toLowerCase()} header={col.header} style={{ width: '10rem' }} sortable filter/>  // filter filterPlaceholder='Search by ' />
                        ))}

                    </DataTable>
                </div>

            </div>

            <div className='mb-5 mt-2'>
                <Button className="pi pi-caret-right mr-2" label="Create A New Dataset" onClick={() => setVisible4(true)} ></Button>
            </div>

        </main>
    );
}

export default ExistingSampleManagement;